export const deleteYleElements = () => {
    const yleHeader = document.querySelector(".ydd-yle-global-header")
    if(yleHeader) yleHeader.style.display = "none";

    const yleHeader2 = document.querySelector(".yle-header-2023")
    if(yleHeader2) yleHeader2.style.display = "none";

    const yleHeader3 = document.querySelector(".ydd-yle-global-header")
    if(yleHeader3) yleHeader2.style.display = "none";

    const yddTags = document.querySelector(".ydd-article-tags__details")
    if(yddTags) yddTags.style.display = "none";

    const yleFooter = document.querySelector(".ydd-footer")
    if(yleFooter) yleFooter.style.display = "none";

}